if (!customElements.get('nd-hero-video')) {
  customElements.define('nd-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.listeners) return;

      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      // Phones wait for the page load event before the first play (which is
      // what starts the preload="none" download), so the poster is the LCP.
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.pageLoaded = document.readyState === 'complete';
      if (!this.pageLoaded) {
        window.addEventListener('load', () => {
          this.pageLoaded = true;
          this.syncPlayback();
        }, { once: true, signal: this.listeners.signal });
      }
      const bounds = this.getBoundingClientRect();
      this.visible = bounds.bottom > 0 && bounds.top < window.innerHeight;
      // One controller owns autoplay, motion preferences, and visibility.
      this.video.autoplay = false;
      this.video.muted = true;

      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      this.motion.addEventListener('change', () => this.syncPlayback(), options);
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.syncPlayback();
      });
      this.observer.observe(this);
      this.syncPlayback();
    }

    shouldPlay() {
      if (this.mobile?.matches && !this.pageLoaded) return false;
      return this.isConnected && this.visible && !document.hidden && !this.motion.matches;
    }

    syncPlayback() {
      if (this.shouldPlay()) this.play();
      else this.video.pause();
    }

    play() {
      if (!this.shouldPlay()) return;
      this.video.play().catch(() => {
        // Respect autoplay restrictions and leave the still poster in place.
      }).finally(() => {
        if (!this.shouldPlay()) this.video.pause();
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.listeners?.abort();
      this.listeners = null;
      this.video?.pause();
    }
  });
}
